import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { SKILL_LEVEL_ORDER, SKILL_TYPE_CONFIG, SKILL_LEVEL_LABELS } from '@/constants/SkillConstants';
let InstructorSkillIcons = class InstructorSkillIcons extends Vue {
    skills;
    showLevels;
    parseSkill(skill) {
        const parts = skill.split('-');
        if (parts.length < 2) {
            return null;
        }
        const level = parts[parts.length - 1];
        const type = parts.slice(0, -1).join('-');
        return { type, level };
    }
    get uniqueSkillTypes() {
        const types = new Set();
        const result = [];
        for (const skill of this.skills) {
            const parsed = this.parseSkill(skill);
            if (!parsed || types.has(parsed.type))
                continue;
            types.add(parsed.type);
            result.push({ type: parsed.type, level: '' });
        }
        return result;
    }
    get highestSkills() {
        const skillMap = {};
        for (const skill of this.skills) {
            const parsed = this.parseSkill(skill);
            if (!parsed)
                continue;
            const existing = skillMap[parsed.type];
            if (!existing) {
                skillMap[parsed.type] = parsed;
            }
            else {
                const existingIndex = SKILL_LEVEL_ORDER.indexOf(existing.level);
                const newIndex = SKILL_LEVEL_ORDER.indexOf(parsed.level);
                if (newIndex > existingIndex) {
                    skillMap[parsed.type] = parsed;
                }
            }
        }
        return Object.values(skillMap);
    }
    get displaySkills() {
        return this.showLevels ? this.highestSkills : this.uniqueSkillTypes;
    }
    getIconSrc(type) {
        const config = SKILL_TYPE_CONFIG[type];
        if (config) {
            return require(`@/assets/icons/${config.icon}`);
        }
        return '';
    }
    getColorFilter(level) {
        // If no level (showLevels=false), return black
        if (!level) {
            return 'none';
        }
        // CSS filters to convert black SVG to specific colors (darker metallic tones)
        switch (level) {
            case 'junior':
                // Dark copper (#8B4513)
                return 'invert(25%) sepia(70%) saturate(700%) hue-rotate(346deg) brightness(95%) contrast(95%)';
            case 'medior':
                // Dark gray (#5F5F5F)
                return 'invert(38%) sepia(0%) saturate(0%) brightness(100%) contrast(90%)';
            case 'senior':
                // Dark goldenrod (#B8860B)
                return 'invert(45%) sepia(90%) saturate(600%) hue-rotate(25deg) brightness(95%) contrast(95%)';
            default:
                return 'none';
        }
    }
    getTooltipText(skill) {
        const typeConfig = SKILL_TYPE_CONFIG[skill.type];
        const typeLabel = typeConfig ? typeConfig.label : skill.type;
        if (!this.showLevels || !skill.level) {
            return typeLabel;
        }
        const levelLabel = SKILL_LEVEL_LABELS[skill.level] || skill.level;
        return `${typeLabel} - ${levelLabel}`;
    }
};
__decorate([
    Prop({ default: () => [] })
], InstructorSkillIcons.prototype, "skills", void 0);
__decorate([
    Prop({ default: false })
], InstructorSkillIcons.prototype, "showLevels", void 0);
InstructorSkillIcons = __decorate([
    Component
], InstructorSkillIcons);
export default InstructorSkillIcons;
